import { gql } from "@apollo/client";

export const bestTimesQuery = gql`
  query BestTimes($linkName: String!, $slug: String!, $body: ZonedDayTimeSlotRangeInput) {
    viewer {
      user {
        id
      }
      schedulingLinkDetails(linkName: $linkName, slug: $slug, body: $body) {
        __typename
        ... on GraphEntityError {
          message
          __typename
        }
        ... on SchedulingLinkDetails {
          suggestedSlotsByDate {
            date
            suggestedSlots {
              timeRange {
                startTime {
                  dateOrDateTime
                  timeZone
                  millis
                  timeZone
                }
                endTime {
                  dateOrDateTime
                  timeZone
                  millis
                  timeZone
                }
              }
              tag
            }
          }
          publicMeetingSettings {
            endOfAvailability {
              millis
            }
          }
        }
      }
    }
  }
`;
